export default "__VITE_ASSET__BC78MotC__"